import { autoinject, bindingMode } from 'aurelia-framework';
import { ComponentBase } from 'app/shared/lib/essette-site';
import { apiCall } from 'app/shared/lib/essette-api';
import { FaxService } from 'app/fm/services/fax-service';
import * as FM from 'app/fm/models/essette-api';
import { bindable } from 'aurelia-typed-observable-plugin';
import { TransitionalManager } from 'app/shared/lib/transitional/manager';
import { IQueryLoadOptions } from 'app/shared/lib/api/api-types';

@autoinject()
export class AttachDocumentAction extends ComponentBase {

    ////****************** Fields and Properties ************************************////
    @bindable.stringNull({ defaultBindingMode: bindingMode.toView, changeHandler: 'reload' })
    protected queueId: string | null = null;

    @bindable
    private faxDoc!: FM.FaxDocument;

    @bindable
    public returnToQueue!: () => Promise<void>;

    private queueActions: FM.FaxQueueAction[] | undefined = [];
    private queue: FM.FaxQueue | null = null;

    protected canCreateAuth: boolean = false;

    ////****************** Element References ***************************************////


    ////****************** Lifecycle events (in order of execution) *****************////
    constructor(
        private readonly service: FaxService,
        private readonly transitional: TransitionalManager,
        ...rest: any[]) {
        super(...rest);
        this.checkPermissions();
    }
    //protected async activate(params: any, routeConfig: RouteConfig, navInstruction: NavigationInstruction): Promise<void> { }
    //protected created(owningView: View, myView: View): void { }
    protected bind(bindingContext: Object, overrideContext: Object): void {
        this.reload();
    }

    ////****************** Events ***************************************************////

    ////****************** Functions ************************************************////
    private async checkPermissions(): Promise<void> {
        await this.accountContext.load();
        this.canCreateAuth = this.accountContext.hasRouteAccess('um.manage-auths.create');
    }

    public async reload(): Promise<void> {
        await this.loadQueue(this.queueId!);

    }

    protected generateActionLink(action: FM.FaxQueueAction): string {
        if(!!action.page?.code) {
            let actionLink = `#/${action.page.href}?faxDocumentId=${this.faxDoc.id}`
            if(action.code === 'CM.Case.Attach') actionLink += '&origin=FM.Fax';
            return actionLink;
        }
        else {
            let url = `#/${this.transitional.route}/${action.page?.id}/FM.Document|${this.queueId}|${this.faxDoc.id}`;

            if(action.page?.id === '6007') {
                url += this.queue?.parameters?.find(({ id }) => id === '6001') == undefined ? "|0" : "|" + this.queue?.parameters?.find(({ id }) => id === '6001')?.argument;
                url += this.queue?.parameters?.find(({ id }) => id === '6002') == undefined ? "|0" : "|" + this.queue?.parameters?.find(({ id }) => id === '6002')?.argument;
            }

            return url;
        }
    }

    public async cancelAndReturn(): Promise<void> {
        this.returnToQueue();
    }

    ////****************** Service Calls ********************************************////

    @apiCall
    private async loadQueue(queueId: string): Promise<void> {
        const includes: string[] = ['parameters', 'actions', 'actions.page'];
        try {
            const response = await this.service.loadQueue(queueId, includes);
            this.queue = response.results[0];
            this.queueActions = this.queue.actions?.filter(action => {
                if(action.code === 'UM.Auth.Attach') return this.canCreateAuth;
                else return true;
            });
        } catch(error) {
            throw error;
        }
    }

}
